export function getCartItem(cart, sectionName, sectionType, id) {
  try {
    if (!cart || !sectionName || !sectionType || !id) {
      return false;
    }
    const cartSubSection = cart?.cartResponse?.tierContent?.[0]?.sections?.section?.find(s => s?.sectionName?.toUpperCase() === sectionName?.toUpperCase())?.subSections?.subSection?.find(s => s?.sectionType?.toUpperCase() === sectionType?.toUpperCase());
    const cartItem = cartSubSection?.products?.find(p => p?.id === id || p?.prodId === id)
      || cartSubSection?.promotions?.find(p => p?.id === id || p?.promoId === id)
      || cartSubSection?.promos?.find(p => p?.id === id || p?.promoId === id);
    return cartItem || null;
  } catch (e) {
    return null;
  }
}
